export enum VrstaKvizPitanja {
    Single = 'Single',
    Multi = 'Multi',
    Connect = 'Connect',
}
